import {
  type DemoPageProps,
  useDemoPageProps,
} from './DemoPage/DemoPageContext';
import {
  type OverlayPageProps,
  useOverlayPageProps,
} from './OverlayPage/OverlayPageContext';

export const useDemoOrOverlayProps = (): DemoPageProps | OverlayPageProps => {
  const demoPageProps = { ...useDemoPageProps() };
  const overlayPageProps = { ...useOverlayPageProps() };
  return demoPageProps.demoId ? demoPageProps : overlayPageProps;
};
